import { observable, action, runInAction, toJS } from 'mobx'
import memoize from 'memoizee'
import orderBy from 'lodash/orderBy'
import { task } from 'mobx-task'

export default class ProjectTypeState {
  stepId = 'ProjectType'
  title = 'Hi, how can we help you?'
  trackingId = 'Onboarding - Project Selection'

  @observable.ref legend = null
  @observable legends = []

  constructor ({ wizard }) {
    this.wizard = wizard
    this.rootStore = wizard.rootStore
    this.hideBackButton = true
    this.activate = this.activate.wrap(fn => memoize(fn, { promise: true, length: 0 }))
  }

  @task async activate () {
    const legends = await this.rootStore.api.legends.find()
      .then(arr => Promise.all(arr.map(l => this.rootStore.api.legends.get(l.id))))
    runInAction(() => {
      const mapped = orderBy(legends.map(l => ({
        additionalFees: [], // default
        ...l
      })), ['viewOrder'])
      this.legends.replace(mapped)
    })
  }

  @action selectType (type) {
    this.legend = typeof type === 'string'
      ? this.legends.find(x => x.id === type)
      : type

    this.wizard.next()
  }

  serializeToJob () {
    return {
      legend: toJS(this.legend)
    }
  }

  hydrate (job) {
    if (job.legend) {
      this.legend = toJS(job.legend)
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/ProjectType/ProjectTypeState.js